module.exports = __webpack_public_path__ + "static/media/intro_placeholder.2f5a4ac1.jpg";